<template>
    <div>
        <h1 style="font-size: 24px; color: black;">代理投放汇总表</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <span> 应用名称： </span>
                    <el-select  v-model="queryData.appId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option
                                v-for="item in appList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <span> 投放媒体： </span>
                    <el-select  v-model="queryData.mediaId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="7">
                        <span > 日期：</span>
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="monthrange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始月份"
                                end-placeholder="结束月份"
                                >
                        </el-date-picker>
                </el-col>
                <el-col :span="5">
                    <el-button  type="primary" @click="queryList">查询</el-button>
                </el-col>
            </el-row>
        </el-card>
        <br>
        <el-row :gutter="16">
            <el-col :span="5">
                <div class="sum-style">
                    <el-card shadow="always" :body-style="sumStyle">
                        <p>现金消耗总计</p>
                        <p>￥：{{sumData.totalRealCost | thousandthOnly}}</p>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="5">
                <div class="sum-style">
                    <el-card shadow="always" :body-style="sumStyle">
                        <p>投放消耗总计</p>
                        <p>￥：{{sumData.totalCost | thousandthOnly}}</p>
                    </el-card>
                </div>
            </el-col>
            <el-col :span="5">
                <div class="sum-style">
                    <el-card shadow="always" :body-style="sumStyle">
                        <p>付款总计</p>
                        <p>￥：{{sumData.totalPaymentMoney | thousandthOnly}}</p>
                    </el-card>
                </div>
            </el-col>
        </el-row>
        <br>
        <el-table border :data="topicList"  >
<!--                <el-table-column  label="id"  prop="id" ></el-table-column>-->
            <el-table-column  label="月份时间"  prop="dt" >
                <template slot-scope="scope">
                    {{ scope.row.dt | dateFormat}}
                </template>
            </el-table-column>
            <el-table-column  label="应用"  prop="appId" >
                <template slot-scope="scope">
                    {{ scope.row.appId | commonFilter(appObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="投放媒体"  prop="mediaId" >
                <template slot-scope="scope">
                    {{ scope.row.mediaId | commonFilter(mediaObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="投放代理公司"  prop="companyId" >
                <template slot-scope="scope">
                    {{ scope.row.companyId | commonFilter(companyObj)}}
                </template>
            </el-table-column>
            <el-table-column  label="关键词"  prop="keyword" ></el-table-column>
            <el-table-column  label="投放现金消耗"  prop="realCost" ></el-table-column>
            <el-table-column  label="投放总消耗"  prop="cost" ></el-table-column>
            <el-table-column  label="关联付款单ID"  prop="paymentId" ></el-table-column>
            <el-table-column  label="付款金额"  prop="paymentMoney" ></el-table-column>
            <el-table-column  label="是否已经付款"  prop="paymentState" >
                <template slot-scope="scope">
                    {{ scope.row.paymentState | yesOrNo }}
                </template>
            </el-table-column>
            <el-table-column  label="操作" align="center">
            </el-table-column>
        </el-table>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="pageSizes"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import {
       LcProxyMonthDataList,
    } from "@/http/financialApi";
    import {states, settlementTypes} from '@/constants/common/basic-data'
    import settingMix from '@/utils/mix/common-setting'
    import DateUtil from '@/utils/DateUtil'
    import pageMix from '@/utils/mix/page'
    export default {
        name: "LcProxyMonthData",
        mixins: [settingMix,pageMix],
        data(){
           return{
               dialogVisible: false,
               dialogTitle :'',
               queryData: {
                   appId: -1,
                   mediaId: -1,
                   timeDate: ['', ''],
               },
               topicList:[],
               needGetApp: true,
               appList:[],
               needDept: true,
               deptObj: {},
               needGetMedia: true,
               mediaType: 2,
               mediaObj: {},
               needGetCompany: true,
               companyObj: {},
               states: states,
               settlementTypes: settlementTypes,
               sumData:{
                   totalRealCost: 0.0,
                   totalCost: 0.0,
                   totalPaymentMoney: 0.0
               },
               sumStyle: {
                   backgroundColor: 'rgba(0, 128, 110, 0.94)',
                   color: 'white',
                   fontWeight: 'bold',
                   fontSize: '16px',
                   padding: 0,
                   height: '70px',
                   display: 'flex',
                   // flexDirection: 'column',
                   alignItems: 'center',
                   justifyContent: 'center'
               },
           }
        },
        methods :{
            queryList(){
                let queryTrueData = {appId: this.queryData.appId, mediaId: this.queryData.mediaId}
                console.log(this.queryData.timeDate)
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                queryTrueData = Object.assign(queryTrueData, this.page)
                console.log(queryTrueData)
                LcProxyMonthDataList(queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                       this.topicList=resp.data.info.content;
                        // eslint-disable-next-line no-undef,no-prototype-builtins
                        if(resp.data.info.hasOwnProperty("totalRealCost")){
                            this.sumData = {totalRealCost: resp.data.info.totalRealCost, totalCost: resp.data.info.totalCost, totalPaymentMoney: resp.data.info.totalPaymentMoney}
                        }
                        this.setTotal(resp.data.info)
                    }
                })
            },
            initDateRange(){
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(1)
            }
        },
        created() {
            this.initDateRange()
            this.queryList();
        },
    }
</script>

<style scoped>
    .sum-style{
        height: 70px;
        width: 300px;
    }
</style>
